import React from 'react';
import theme from '../style/theme';

interface IconProps {
  fillColor?: string;
}

const SendIcon: React.FC<IconProps> = ({
  fillColor = `${theme.colors.g3}`,
}) => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="18" cy="18" r="12" fill="#9747FF" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.9735 13.4248C17.2483 13.1528 17.6207 13 18.0089 13C18.3972 13 18.7696 13.1528 19.0443 13.4248L24.5711 18.9021C24.7071 19.037 24.815 19.1972 24.8886 19.3735C24.9622 19.5497 25 19.7386 25 19.9294C25 20.1202 24.962 20.3091 24.8883 20.4853C24.8146 20.6616 24.7067 20.8217 24.5706 20.9565C24.4345 21.0914 24.2729 21.1984 24.0951 21.2713C23.9173 21.3443 23.7268 21.3818 23.5343 21.3818C23.3419 21.3817 23.1514 21.3441 22.9736 21.2711C22.7958 21.198 22.6343 21.091 22.4983 20.9561L18.0089 16.5053L13.5196 20.9561C13.3845 21.0949 13.2229 21.2056 13.0441 21.2818C12.8654 21.358 12.6732 21.3982 12.4786 21.3999C12.2841 21.4017 12.0911 21.365 11.911 21.2921C11.7309 21.2191 11.5673 21.1114 11.4296 20.975C11.292 20.8387 11.1831 20.6766 11.1094 20.4981C11.0356 20.3196 10.9985 20.1283 11 19.9355C11.0016 19.7426 11.042 19.552 11.1187 19.3747C11.1954 19.1975 11.3069 19.0371 11.4468 18.903L16.9725 13.4238L16.9735 13.4248Z"
        fill="white"
      />
    </svg>
  );
};

export default SendIcon;
